"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, ShieldCheck } from "lucide-react";
import { ANALYTICS_CONSENT_EVENT, ANALYTICS_CONSENT_KEY } from "@/components/umami-analytics";

const STORAGE_KEY = "elenails_cookie_notice_seen";

export function CookieNotice() {
  const pathname = usePathname();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(window.localStorage.getItem(STORAGE_KEY) !== "1"), 0);
    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) return null;
  const isAuthPage = ["/connexion", "/inscription", "/verification", "/mot-de-passe-oublie", "/reinitialiser", "/initialisation-proprietaire"].some((path) => pathname === path || pathname.startsWith(path + "/"));

  function chooseAnalytics(consent: "accepted" | "declined") {
    window.localStorage.setItem(STORAGE_KEY, "1");
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, consent);
    window.dispatchEvent(new Event(ANALYTICS_CONSENT_EVENT));
    setVisible(false);
  }

  return (
    <aside className={`cookie-notice${isAuthPage ? " cookie-notice-auth" : ""}`} role="dialog" aria-live="polite" aria-label="Information sur la confidentialité">
      <div className="cookie-notice-copy">
        <div className="cookie-notice-heading"><span className="cookie-notice-icon" aria-hidden="true"><Cookie size={16} /></span><strong>Votre confidentialité</strong></div>
        <p>Le site utilise des cookies et du stockage local pour ses fonctions essentielles : comptes, rendez-vous, avis et sécurité. Avec votre accord, Umami mesure l’audience de façon agrégée, sans suivi publicitaire.</p>
        <div className="cookie-notice-links"><Link href="/cookies">Détails des cookies</Link><Link href="/confidentialite">Confidentialité</Link></div>
      </div>
      <div className="cookie-notice-actions">
        <Button type="button" size="sm" variant="outline" onClick={() => chooseAnalytics("declined")}>Continuer sans statistiques</Button>
        <Button type="button" size="sm" onClick={() => chooseAnalytics("accepted")}><ShieldCheck data-icon="inline-start" /> Autoriser les statistiques</Button>
      </div>
    </aside>
  );
}
